export function slider() {
	$('.projekte-slider').slick({
		dots: true,
	})
	$('.kundenstimmen-slider').slick()
	$('.case-study-slider').slick()
	$('.project-listing__gallery').slick()
	$('.simple-slider').slick({
		dots: true,
	})

	$(".referenzen-slider").slick({
		dots: true,
	})

	$('.slider-3').slick({
		slidesToShow: 3,
		slidesToScroll: 3,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				},
			},
			{
				breakpoint: 620,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	})

	$('.slider-3-team').slick({
		slidesToShow: 3,
		slidesToScroll: 3,
		dots:true,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				},
			},
			{
				breakpoint: 620,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	})

	$('.leistungen-teaser-container').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		mobileFirst: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: 'unslick',
			},
		],
	})
}
